import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { isExtensionMessageChannelError } from './app/core/utils/extension-message-error.util';
import { environment } from './environments/environment';

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (!isExtensionMessageChannelError(event.reason)) {
      return;
    }
    event.preventDefault();
    if (!environment.production) {
      console.debug(
        '[SGI] Promessa rejeitada por extensão do navegador (não é erro da aplicação).',
        event.reason,
      );
    }
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
